module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdd"
  }, [_c('span', {
    attrs: {
      "href": "#/pagetitre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdd"
  }, [_c('span', {
    attrs: {
      "href": "#/ident1#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2#niv1-001"
    }
  }, [_vm._v("The Trusty IMRD Template")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2#niv1-002"
    }
  }, [_vm._v("Writing from Conclusions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2#niv1-003"
    }
  }, [_vm._v("Sections of a Project Report")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1   The Models")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-004"
    }
  }, [_vm._v("Archimedes's Law")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-005"
    }
  }, [_vm._v("Redesigning a Flowmeter")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-006"
    }
  }, [_vm._v("Mooring System Design")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_vm._v("2   Writing for Real People to Read")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-007"
    }
  }, [_vm._v("Audience, Purpose, and Context")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-008"
    }
  }, [_vm._v("Putting Them All Together")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap3"
    }
  }, [_vm._v("3   Writing on ACID")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap3#niv1-009"
    }
  }, [_vm._v("Writing in Engineering Environments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap3#niv1-010"
    }
  }, [_vm._v("What to Write While You're Working")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap3#niv1-011"
    }
  }, [_vm._v("Formatting the Final Document")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap4"
    }
  }, [_vm._v("4   Conclusions and Recommendations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap4#niv1-012"
    }
  }, [_vm._v("Three Kinds of Conclusions (and Some Pseudoconclusions)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap4#niv1-013"
    }
  }, [_vm._v("Formulating the Conclusions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap4#niv1-014"
    }
  }, [_vm._v("Formatting the Conclusions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap4#niv1-015"
    }
  }, [_vm._v("Recommendations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap4#niv1-016"
    }
  }, [_vm._v("Critiquing the Conclusions and Recommendations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5   Abstracts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elevator Talk")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keeping It Short")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing the Right Content")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Abstract")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6   Introductions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drafting the Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bring the introduction to closure.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7   Literature Review")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drafting the Literature Review")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Literature Review")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8   Discussion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strategies for Writing the Discussion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major Factors of the Discussion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Discussion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9   Titles and Headings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drafting the Title")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Headings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Styles in Your Word Processor")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Title")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10   Graphics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Developing Good Graphics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graphs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Line Drawings, Schematics, and Maps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Graphics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11   Presentations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing for the Audience")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Designing the Presentation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Designing the Visual Elements")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Delivering the Talk")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watching for Good Examples")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Presentation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12   Proposals")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Developing Detailed (SMART) Objectives")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meeting the SMART Criteria")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planning the Project's Deliverables")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drafting the Proposal Sections")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assembling the Final Proposal")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Proposal")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13   Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plagiarism and Copyright Law")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Law")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plagiarism")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engineering Report Concerns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14   Executive Summaries and Extended Abstracts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Executive Summaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Extended Abstracts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Executive Summary or Extended Abstract")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15   Learning from the Literature")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What to Read and How to Read It")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using APPLES to Improve Your Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing Electronic or Hard-Copy Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Bibliographic Software")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Overview of Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16   Correspondence")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultrashort Messages")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Email")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letters")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memorandums")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing the Communication")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17   Writing Styles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Is the “Style” in a Style Guide?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Active and Passive Voice")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tired Constructions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Usage Tips")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commonly Misused or Overused Terms")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adding Emphasis to Text")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Punctuation and Special Characters")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0